import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwareFormSubmit,
	envAwarePost
} from '../util/util'

import {
	getCurrentDateTime,
} from '../util/datetime'


export const editFormOrganization = createAsyncThunk(
	'editFormOrganization',
	async payload => envAwarePost(
		'api/customForms/',
		{action:'editFormOrganization',...payload}
	)
)

export const getAllCustomForms = createAsyncThunk(
	'getAllCustomForms',
	async (payload) => (envAwarePost('api/customForms/api/', {action:'getAllCustomForms',...payload}))
)

export const getAllAssignedForms = createAsyncThunk(
	'getAllAssignedForms',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const getAllFormsForClient = createAsyncThunk(
	'getAllFormsForClient',
	async (payload) => (envAwarePost('api/customForms/api/', {
		action:'getAllFormsForClient',
		...payload
	}))
)

export const createForm = createAsyncThunk(
	'createForm',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const deleteForm = createAsyncThunk(
	'deleteForm',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const deleteAllForms = createAsyncThunk(
	'deleteAllForms',
	async () => (envAwarePost('api/customForms/api/', { action: "deleteAllForms" }))
)

export const updateFormTitle = createAsyncThunk(
	'updateFormTitle',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const updateFormComplete = createAsyncThunk(
	'updateFormComplete',
	async (payload) => (envAwarePost('api/customForms/api/', { ...payload, action: "updateFormComplete" }))
)

export const getCustomFormById = createAsyncThunk(
	'getCustomFormById',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
		.then(res => {
			let parsedData = {};
			res.data.map(question => {
				let category = question.category_name
				parsedData[category] = parsedData[category] ? [...parsedData[category], question] : [question]
			})
			let owner_id = res.owner_id
			let complete_status = res.complete_status;
			let default_form = res.default_form
			return { parsedData, owner_id, complete_status,default_form }
		})
)

export const getCustomFormTitleById = createAsyncThunk(
	'getCustomFormTitleById',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const getQuestionOptions = createAsyncThunk(
	'getQuestionOptions',
	async (payload) => (envAwarePost('api/customForms/api/', payload))
)

export const updateField = createAsyncThunk(
	"updateField",
	async (payload) => {
		envAwarePost("api/customForms/api/", {
			...payload, action: "answerFormQuestion"
		})
	}
)

export const getClientsForAssigning = createAsyncThunk(
	"getClientsForAssigning",
	(payload) => envAwarePost("api/customForms/api/", {
		action: "getClientsForAssigning", ...payload
	})
)

export const addFormToMultipleClients = createAsyncThunk(
	"addFormToMultipleClients",
	(payload) => envAwarePost("api/customForms/api/", {
		action: "addFormToMultipleClients", ...payload
	})
)

export const createFormCategory = createAsyncThunk(
	"createFormCategory",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const removeFormCategory = createAsyncThunk(
	"removeFormCategory",
	(payload) => envAwarePost("api/customForms/api/", {
		action:"removeFormCategory",
		...payload
	})
)

export const createFormQuestion = createAsyncThunk(
	"createFormQuestion",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const updateFormQuestion = createAsyncThunk(
	"updateFormQuestion",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const deleteFormQuestion = createAsyncThunk(
	"deleteFormQuestion",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const updateDBQuestionSequence = createAsyncThunk(
	"updateDBQuestionSequence",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const copyForm = createAsyncThunk(
	"copyForm",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const addFormToClient = createAsyncThunk(
	"addFormToClient",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const addFormToGymLibrary = createAsyncThunk(
	"addFormToGymLibrary",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload, action: "addFormToGymLibrary"
	})
)

export const removeFormFromClient = createAsyncThunk(
	"removeFormFromClient",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)

export const removeFormMultipleClients = createAsyncThunk(
	"removeFormMultipleClients",
	(payload) => envAwarePost("api/customForms/api/", {
		...payload
	})
)




const customFormsAdapter = createEntityAdapter({
	selectId: ent => ent.form_id,
})


const customFormsSlice = createSlice({
	name: 'customForms',
	initialState: {
		//id of the client if forms were fetched for a specific
		//client
		clientId:null,
		formList: customFormsAdapter.getInitialState(),
		singleForm: {},
		questionCategories: [],
		answerType: [],
		formTitle: "",
		owner_id: "",
		unassignedClients: [],
		assignedClients: [],
		complete: false,
		default_form: "0",
		status: 'init',
		multiFormsModal:{
			show:false,
			forms:[],
			programs:[]
		}
	},
	reducers: {
		setMultiFormsModal : (state,action) => {
			state.multiFormsModal = {
				...state.multiFormsModal,
				...action.payload
			}
		},
		updateCompleteStatus: (state, action) => {
			state.complete = action.payload;
		},
		calcAge: (state, action) => {
			let { answer, category, answer_id, question_id } = action.payload;

			if (answer_id === "birthdate") {

				function calcAge(userDateinput) {

					// convert user input value into date object
					var birthDate = new Date(userDateinput);

					// get difference from current date;
					var difference = Date.now() - birthDate.getTime();

					var ageDate = new Date(difference);
					var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
					return calculatedAge
				}

				let updatedAge = calcAge(answer)
				state.singleForm[category].map(question => {
					if (question.question_id === question_id) {
						question.answer_array.map(answerItem => {
							if (answerItem.answer_type === "Hardcoded") {
								return answerItem.answer_values.answer = updatedAge;
							}
						})
					}
					return question
				})
			}
		},
		updateLocalSequence: (state, action) => {
			const { updatedOrder, category } = action.payload
			console.log(updatedOrder, "updateOrder")
			state.singleForm[category] = updatedOrder
		}



	},
	extraReducers: {
		[getAllFormsForClient.pending]: (state, action) => {
			state.status='pending'
			const { client_id } = action.meta.arg
			state.clientId = client_id
		},
		[getAllFormsForClient.fulfilled]: (state, action) => {
			state.status='idle'
			const { success, data } = action.payload;
			if (success === "1") {
				customFormsAdapter.setAll(state.formList, data)
			}
		},
		[getAllAssignedForms.fulfilled]: (state, action) => {
			const { success, data } = action.payload;
			if (success === "1") {
				if (data) {
					customFormsAdapter.setAll(state.formList, data)
				}
			}
		},
		[getAllCustomForms.pending]: (state, action) => {
			state.clientId = null
			state.status = 'pending'
		},
		[getAllCustomForms.fulfilled]: (state, action) => {
			state.status = 'idle'
			const { success, data } = action.payload;
			if (success === "1") {
				customFormsAdapter.setAll(state.formList, data)
			}
		},
		[copyForm.fulfilled]: (state, action) => {
			const { success, data } = action.payload;
			if (success === "1") {
				customFormsAdapter.addOne(state.formList, data)
			}
		},
		[createForm.fulfilled]: (state, action) => {
			const { success, data } = action.payload;
			if (success === "1") {
				customFormsAdapter.addOne(state.formList, data)
			}
		},
		[getClientsForAssigning.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			if (success === "1") {
				state.unassignedClients = data.unassigned_clients;
				state.assignedClients = data.assigned_clients;
			}
		},
		[deleteForm.fulfilled]: (state, action) => {
			const { success, data } = action.payload;
			if (success === "1") {
				customFormsAdapter.removeOne(state.formList, data.form_id)
			}
		},
		[removeFormCategory.fulfilled]: (state, action) => {
			const {data, success} = action.payload
			if (success === "1") {
				state.questionCategories = state.questionCategories.filter(item=>item.id != data.category_id)
			}
		},
		[updateFormTitle.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			let updateObject = {
				changes: {
					form_title: data.form_title
				},
				id: data.form_id
			}

			if (success === "1") {
				customFormsAdapter.updateOne(state.formList, updateObject)
			}
		},
		[getCustomFormById.fulfilled]: (state, action) => {
			state.singleForm = action.payload.parsedData;
			state.owner_id = action.payload.owner_id;
			state.default_form = action.payload.default_form;
			state.complete = action.payload.complete_status === "1" ? true : false;
		},
		[getCustomFormTitleById.fulfilled]: (state, action) => {
			state.formTitle = action.payload.form_title
		},
		[getCustomFormTitleById.fulfilled]: (state, action) => {
			state.formTitle = action.payload.form_title
		},
		[getQuestionOptions.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			if (success === "1") {
				state.answerType = data.answer_types
				//let categoryList = [{id:"999999", category_name:"Add New Category", user_id_number : "999999"}, ...data.categories] 
				state.questionCategories = data.categories
			}
		},
		[deleteFormQuestion.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			if (success === "1") {
				let category_name = data.category_name;
				let updatedCategory = state.singleForm[category_name].filter(question => question.question_id != data.question_id)
				state.singleForm[category_name] = updatedCategory
			}
		},
		[createFormCategory.fulfilled]: (state, action) => {
			const { success, data } = action.payload

			if (success === "1") {
				state.questionCategories.push({ "id": data.category_id, "category_name": data.category_name })
			}
		},
		[editFormOrganization.pending]: (state,action)=>{
			state.singleForm = action.meta.arg.newForm
		},
		[addFormToClient.pending]: (state,action)=>{
			const {form_id} = action.meta.arg
			customFormsAdapter.updateOne(state.formList,{id:form_id,changes:{assigned:true}})
		},
		[removeFormFromClient.pending]: (state,action)=>{
			const {form_id} = action.meta.arg
			customFormsAdapter.updateOne(state.formList,{id:form_id,changes:{assigned:false,complete:'0'}})
		},
		[updateFormComplete.pending]: (state,action)=>{
			const {form_id,complete_status} = action.meta.arg
			customFormsAdapter.updateOne(
				state.formList,
				{
					id:form_id,
					changes:{
						complete:complete_status,
						date_completed:getCurrentDateTime()
					}
				}
			)
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllCustomForms,
	selectById: selectcustomFormsById,
	selectIds: selectCustomFormsIds,
} = customFormsAdapter.getSelectors(state => state.customForms.formList)

export const { 
	calcAge, 
	updateLocalSequence, 
	updateCompleteStatus,
	setMultiFormsModal
} = customFormsSlice.actions;


export default customFormsSlice.reducer